import { Component, OnInit } from '@angular/core';
import { DisciplinaComponent } from './disciplina/disciplina.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs';
import { DisciplinaService } from '../services/disciplina-service';
import { AlunoService } from '../services/aluno-service';
import { ProvaService } from '../services/prova-service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  disciplinas: Observable<any[]>;
  alunos: Observable<any[]>;
  provas: Observable<any[]>;

  showDisciplina = false;
  showAluno = false;
  showProva = false;
  showListaAluno = false;
  showListaDisciplina = false;
  showListaProva = false;
  constructor(public dialog: MatDialog,
    public disciplinaService: DisciplinaService,
    public alunoService: AlunoService,
    public provaService: ProvaService) { }

  ngOnInit() {
    this.disciplinas = this.disciplinaService.get();
    this.alunos = this.alunoService.get();
    this.provas = this.provaService.get();
  }

  closeAll() {
    this.showAluno = this.showDisciplina = this.showProva = false;
    this.showListaAluno = false;
    this.showListaDisciplina = false;
    this.showListaProva = false;
  }

  listaAluno() {
    this.closeAll();
    this.showListaAluno = true;
  }

  listaDisciplina() {
    this.closeAll();
    this.showListaDisciplina = true;
  }

  listProva() {
    this.closeAll();
    this.showListaProva = true;
  }


  addProva() {
    this.closeAll();
    this.showProva = true;

  }
  addDisciplina() {
    this.closeAll();
    this.showDisciplina = true;

  }
  addAluno() {
    this.closeAll();
    this.showAluno = true;
  }

}
